export default __webpack_public_path__ + "static/everywhere-lab-visit-2-4c7207c241ae3383ede93b36b822582f.jpg";